import React from 'react';
import { Text, View, Image } from '@react-pdf/renderer';
export const renderCoppergatSignaturePdf = (signature, styles) => (
  <View style={styles.signatureBlock}>
    <Text>Sincerely Yours'</Text>
    <Text>{'\n'}</Text>
    <Text style={styles.signatureTitle}>{signature?.name || ''}</Text>
    <Text style={styles.signatureBold}>{signature?.title || ''}</Text>
    <Text>{signature?.company || 'CopperGAT Cables (Pvt) Ltd'}</Text>
    <Text>{signature?.phone || ''}</Text>
    <Text style={styles.signatureEmail}>{signature?.email || ''}</Text>
  </View>
);

export const renderCoppergatTermsPdf = (terms, styles) => (
  <View style={styles.termsWrapper}>
    <Text style={styles.termsHeader}>Terms & Conditions</Text>
    <View style={styles.termsTable}>
      {terms.map((term, index) => (
        <View key={index} style={styles.termsRow}>
          <Text style={styles.termsLabel}>{term.label}</Text>
          <Text style={styles.termsValue}>
            {term.value}
          </Text>
        </View>
      ))}
    </View>
  </View>
);

export const renderCoppergatSignatureHtml = (signature) => (
  <div style={{ padding: '10px 20px 40px', fontSize: '11px', lineHeight: 1.6 }}>
    <p>Sincerely Yours&apos;</p>
    <br />
    <p style={{ fontWeight: 'bold', fontSize: '12px' }}>{signature?.name || ''}</p>
    <p style={{ fontWeight: 'bold' }}>{signature?.title || ''}</p>
    <p>{signature?.company || 'CopperGAT Cables (Pvt) Ltd'}</p>
    <p>{signature?.phone || ''}</p>
    <p style={{ color: '#0000cc' }}>{signature?.email || ''}</p>
  </div>
);

export const renderCoppergatTermsHtml = (terms) => (
  <div style={{ margin: '20px 20px 0' }}>
    <div
      style={{
        border: '1.5px solid #222',
        fontWeight: 'bold',
        fontSize: '13px',
        textAlign: 'center',
        padding: '6px',
      }}
    >
      Terms & Conditions
    </div>
    <table
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '11px',
        border: '1.5px solid #222',
        borderTop: 'none',
      }}
    >
      <tbody>
        {terms.map((term, index) => (
          <tr key={index}>
            <td
              style={{
                border: '1.5px solid #222',
                padding: '3px 6px',
                fontWeight: 'bold',
                width: '130px',
                verticalAlign: 'top',
                whiteSpace: 'pre-line',
              }}
            >
              {term.label}
            </td>
            <td
              style={{
                border: '1.5px solid #222',
                padding: '3px 6px',
                verticalAlign: 'top',
              }}
            >
              {term.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
